<template>
    <div class="animated fadeIn bonusfrm">        
        <b-card>
            <div slot="header">
                Form - Bonus/Potongan AR Koran
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Number</label></b-input-group-prepend>
                                <b-form-input v-model="model.paymno" readonly></b-form-input>
                            </b-input-group>
                        </b-col>   
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tglpaym" type="date" :state="!$v.model.tglpaym.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                          <b-form-input  v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col lg="8">
                        <b-input-group>
                            <b-input-group-prepend><label>Customer/Agen</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.custinfo" :state="!$v.model.custcode.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuCustomerShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                        </b-col>
                        <b-col lg="4">      
                            <b-input-group >
                                <b-input-group-prepend><span class="p-2">Trx. Amount</span></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.totalbyr" :precision="2" :state="!$v.model.totalbyr.$error"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <!-- <b-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.totalbyr" :precision="2" :state="!$v.model.totalbyr.$error"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row> -->
                </b-col>
                <b-col lg="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>   
              <label><strong>Detail Invoice Settlement</strong></label>
              <b-card no-body class="mt-0">
                    <b-table
                        class="mb-0"
                        ref="tblArpaymdt"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="arpaymdt.items"
                        :fields="arpaymdt.fields"
                        :current-page="arpaymdt.page"
                        :per-page="arpaymdt.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>
                            <template v-slot:cell(nilaibyr)="data">
                            {{data.item.nilaibyr|numFormat}}
                            </template>
                            <template v-slot:cell(invdate)="data">
                            {{data.item.invdate| moment("MMM-YYYY")}}
                            </template>
                            <template v-slot:cell(kasdiskon)="data">
                            {{data.item.kasdiskon|numFormat}}
                            </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editArpaymdt(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delArpaymdt(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                      <template v-slot:row-details="row">
                        <b-card no-body class="row-details-form">
                        <b-row align-h="around">
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Jenis Potongan</label></b-input-group-prepend>
                                    <b-form-select v-model="arpaymdtObj.IDPotongan" :plain="true" :options="potongans" :state="!$v.arpaymdtObj.IDPotongan.$error"></b-form-select>
                                    <b-input-group-prepend><span class="input-group-text">tarif (%)</span></b-input-group-prepend>
                                    <div style="display:inline; width:100px;">
                                        <b-form-input v-model="arpaymdtObj.tarif" type="number" @change="calcPotongan()" min="0" ></b-form-input>
                                    </div>
                                    <b-input-group-append><span class="input-group-text" style="width:100px !important;">%</span></b-input-group-append>
                                </b-input-group>
                                <b-row>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Nilai Potongan</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="arpaymdtObj.kasdiskon" :precision="2" ></my-number>
                                            <b-input-group-prepend><span class="input-group-text">in Original Amt.</span></b-input-group-prepend>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>                            
                            <b-row class="justify-content-center mb-2">
                                <b-button v-if="saveEnabled" class="btn btn-success mr-1" @click="saveArpaymdt()">Update</b-button>
                                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                            </b-row>
                        </b-card>
                      </template>                        
                    </b-table>
                    <b-row>
                      <b-col cols="5">
                        <b-row>
                            <b-button size="sm" class="ml-3" @click="addArpaymdt" :disabled="!(model.custcode)">Add Settlement</b-button>                          
                            <div class="ml-2">
                                Showing {{((arpaymdt.page - 1) * arpaymdt.limit + 1)}}
                                to <span v-if="((arpaymdt.page * arpaymdt.limit)>arpaymdt.total)">{{arpaymdt.total}}</span>
                                    <span v-else>{{arpaymdt.page * arpaymdt.limit}}</span>
                                <strong> of {{arpaymdt.total}} entries </strong>
                            </div>    
                        </b-row>                    
                      </b-col>
                      <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="arpaymdt.limit"  style="width:80px;"/>
                            </b-input-group>
                        </b-col>
                        <b-col cols="5">
                            <b-pagination
                                align="right"
                                :total-rows="arpaymdt.total"
                                :per-page="arpaymdt.limit"
                                v-model="arpaymdt.page"
                            ></b-pagination>
                        </b-col>
                    </b-row>
              </b-card>    
            <b-row >
                <b-col lg="7">
                    <div >
                        <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                    </div>
                </b-col>
                <b-col lg="5" style="text-align-right;">
                    <b-input-group >
                        <b-input-group-prepend><label style="width:180px;">Total Detail Settlement</label></b-input-group-prepend>
                        <b-input-group-prepend>
                            <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData"></lku-cashflow>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
    </div>
</template>
<style lang="scss">
  .bonusfrm {
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
  }
</style>

<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import toastr from "mini-toastr";
import moment from 'moment';
import dropdown from "../../data/dropdown";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCustomer from "../lookup/lkuKoranCust";
import dimension from "../../apis/dimension";
import arpayment from '../../apis/arkoranbonus';
import { validationMixin } from "vuelidate";
import { required, requiredIf, requiredUnless, minValue, minLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { VueMonthlyPicker, myNumber, vDim, lkuCashflow,lkuCustomer},
  mixins: [validationMixin],
  validations: {
        model: {
            uraian: { required },
            tglpaym: { required },
            jenis: { required },
            tgl_terima: { required:(function() {
                if ((this.model.jenis !=='Cheque') && (this.model.jenis !=='Giro')) {
                    return true;
                } else if (this.model.tgl_terima){
                    return true;
                } else return false;
            }) },
            matauang: { required },
            custcode: { required },
            totalbyr: { required, minValue:minValue(0.01) },
            kurstrx: { required, minValue:minValue(0.00000001) }
        },
        arpaymdtObj :{
            invdate: { required },
            IDPotongan : { required }
        },
  }, 
  data() {
    return {
        arGroups : [],
        bankCashAcc:[{kode:'-',namabank:'-'}],
        bankAccount:[{kode:'-',namabank:'-'}],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
        horizontal:true,
        jenisPaym : ['Cheque', 'Giro', 'Transfer', 'Debet R/K', 'Tunai'],
        model:{jenis:'Giro',kodecash:'',kodebank:'',kurstrx:1,tglpaym:'',tgl_terima:'', matauang:'',totalbyr:'', custcode:''},
        lblExchRate:"Exch. Rate ",
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'arpaymdt',        
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        arpaymdt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "invdate",
                    label: "Tgl. Omset yg disettle",
                },
                {
                    key: "kasdiskon",
                    label: "Potongan/Non Kas",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "Potongan",
                    label: "Jenis Potongan/Non Kas",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arpaymdtObj:{invdate:'', kodecash:'',IDPotongan:null, kasdiskon:0, nilaibank:0, nilaibyr:0,nilaidpp:0,totalinv:0},
        monthLabels:dropdown.monthLabels,
        lkuArinvShow: false,
        lkuCustomerShow:false
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    caraBayar(){
        return this.model.jenis;
    },
    bankkas(){
        return this.model.kodebank;
    },
    adaPotongan(){
        return ((this.arpaymdtObj.kasdiskon || 0) != 0);
    },
    IDPotongan(){return this.arpaymdtObj.IDPotongan;},
    adaNilaiBank(){return ((this.arpaymdtObj.nilaibank || 0) != 0);},
  },
  watch: {
    caraBayar: function(jenis) {
        if (jenis==='Tunai') {
            this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
        } else {
            this.bankAccount = this.bankCashAcc.filter(r => r.isbank==1);
        }
    },    
    bankkas: function(kode) {
        let acc = this.bankCashAcc.find(r => r.kode===kode);
        if (acc){
            this.model.nomorrek=acc.nomorrek;
            this.model.matauang=acc.matauang;
            if (this.uanguser.trim() == this.model.matauang.trim()) {
                this.model.kurstrx = 1;
            }
        }
    },    
    IDPotongan: function(kode) {
        let pot = this.potongans.find(r => r.value===kode);
        if (pot){
            this.arpaymdtObj.Potongan=pot.text;
        }
    },    
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      if (this.$route.params.arpaymKey) {
          toastr.info('Loading Payment Detail, please wait')
          try {

            // const data = await arpayment.arpaymdetail(this.$route.params);  
            const [a,b,c,d,data] = await Promise.all([arpayment.currency(),arpayment.bankaccount(),await arpayment.argroup(),await arpayment.potongan(),
                                    arpayment.arpaymdetail(this.$route.params)]) ;            
            this.currency = a;
            this.bankCashAcc = b;
            this.arGroups = c;
            this.potongans = d;
            // this.bankAccount = this.bankCashAcc.filter(r => r.isbank==1);
            const row = data[0][0];
            this.saveEnabled=(row.statusar === 0);
            row.tglpaym = (row.tglpaym) ? moment(row.tglpaym).format('YYYY-MM-DD') : '';
            row.tgl_giro = (row.tgl_giro) ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
            row.tgl_terima = (row.tgl_terima) ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            if (this.model.jenis==='Tunai'){
                this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
            } else {
                this.bankAccount = this.bankCashAcc.filter(r => r.isbank==1);
            }
            this.arpaymdt.items = data[1];
            this.calcTotalDtlPaym();
            this.updateDimHdr = !this.updateDimHdr;
            // console.log('model : ', this.model);
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,b,c,d] = await Promise.all([arpayment.currency(),arpayment.bankaccount(),await arpayment.argroup(),await arpayment.potongan()]) ;
        this.currency = a;
        this.bankCashAcc = b;
        this.arGroups = c;
        this.potongans = d;
        this.bankAccount = this.bankCashAcc.filter(r => r.isbank==1);
        this.model.jenis='Tunai';
        this.model.kurstrx=1;
        this.model.matauang=this.$store.state.user.matauang;
      }
  },
  methods: {
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this.arpaymdtObj.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this.arpaymdtObj.kodecash = lkuData.selected.kodecash;
        this.arpaymdtObj.namacash = lkuData.selected.namacash;
        this.lkuCashflowShow=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) {
            toastr.warn('Detail Form Un Saved');
            return;
        }
        // this.model.tgl_terima=this.model.tglpaym;
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (Math.abs(this.totalDtlPaym - parseFloat(this.model.totalbyr))>0.5) {
            toastr.error('[Transaction Amount] not Balance with [Total Detail Payment]', "ERROR MESSAGE");
        } else {
            // this.model.TableName = 'arpaymtt';
            try {
                // const dimValResult = await dimension.validate(this.model);
                // if (dimValResult.success) {
                    this.model.paymno = this.model.paymno || '';
                    this.model.statusar = this.model.statusar || 0;
                    this.model.statustre = this.model.statustre || 0;
                    this.model.totalbyr = this.model.totalbyr || 0;
                    this.model.bcharge = this.model.bcharge || 0;
                    this.model.settl_amt =this.model.totalbyr || 0;

                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tglpaym = moment(row.tglpaym).format('YYYY-MM-DD');
                    row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : undefined;
                    row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : moment(row.tglpaym).format('YYYY-MM-DD');
                    let newArpaymdts = this.arpaymdt.items.reduce((newArr, item) => {
                        item.invdate = item.invdate ? moment(item.invdate).endOf('month').format('YYYY-MM-DD') : moment(this.model.tglpaym).endOf('month').format('YYYY-MM-DD');
                        if (((item.nilaibyr || 0)+(item.kasdiskon || 0)) != 0) {
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);

                    newArpaymdts.sort((a, b) => {   
                            if ( a.customerid < b.customerid ){
                                return -1;
                            }
                            if ( a.customerid > b.customerid ){
                                return 1;
                            }
                            return 0;
                        });
                    row.arpaymdt = newArpaymdts;
                    await arpayment.insert(row);
                    toastr.success("Complete successfully", "Save Receipt");
                    this.close();
                // } else {
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message || 'Dimension validation error';
                //     toastr.error(msg, "ERROR MESSAGE");
                // }

            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Receipt Error");                
            }

        }
    },
    closeArPayment: function(){
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addArpaymdt : function () {
        this.closeArPayment();
        const obj={_showDetails:true};
        this.arpaymdt.selected = obj;
        for (var key in this.arpaymdtObj) {
            this.arpaymdtObj[key] = '';
        }
        this.arpaymdtObj.invdate=this.model.tglpaym;
        this.arpaymdtObj.kurskeAR=1;
        // this.arpaymdtObj.matauang=this.model.matauang;
        this.arpaymdt.items.push(obj);
        this.arpaymdt.total=this.arpaymdt.items.length;
    },
    editArpaymdt : function (obj,callback) {
        this.closeArPayment();
        this.arpaymdt.selected = obj;
        for (var key in this.arpaymdtObj) {
            this.arpaymdtObj[key] = '';
        }
        for (var key in obj) {
            this.arpaymdtObj[key] = obj[key];
        }
        callback();
    },
    delArpaymdt: function (index) {
        if (index > -1) {
        this.arpaymdt.items.splice(index, 1);
        }
        this.arpaymdt.total=this.arpaymdt.items.length;
        this.calcTotalDtlPaym();
    },
    saveArpaymdt: function (callback) {
        this.arpaymdtObj.nilaibyr = this.arpaymdtObj.nilaibyr || 0;
        this.arpaymdtObj.kasdiskon = this.arpaymdtObj.kasdiskon || 0;
        this.arpaymdtObj.nilaibank = this.arpaymdtObj.nilaibyr;
        this.arpaymdtObj.kurskeAR = 1;
        if (!this.adaPotongan) this.arpaymdtObj.IDPotongan='';
                
        if (this.invalidArpaymdt) {
            console.log('validation : ', this.$v.arpaymdtObj);
            console.log('model obj : ',this.arpaymdtObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
                // this.arpaymdtObj.selisihkurs = this.arpaymdtObj.nilaibank - (this.arpaymdtObj.nilaibyr * this.arpaymdtObj.kurskeAR);
                this.arpaymdtObj.selisihkurs = 0;
                for (var key in this.arpaymdtObj) {
                    this.arpaymdt.selected[key] = this.arpaymdtObj[key];
                }
                this.arpaymdt.selected.invdate=moment(this.arpaymdtObj.invdate).endOf('month').format('YYYY-MM-DD');
                this.calcTotalDtlPaym();
                this.arpaymdt.selected._showDetails=false;
                if (callback) callback();
       }
    },

    calcPotongan : function() {
        let pot = this.potongans.find(r => r.value=== this.arpaymdtObj.IDPotongan);
        if (pot){
            if (pot.pajak) {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.nilaidpp * parseInt(this.arpaymdtObj.tarif,10) / 100;
            } else {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * parseInt(this.arpaymdtObj.tarif,10) / 100;
            }
        } else {
            this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * parseInt(this.arpaymdtObj.tarif,10) / 100;
        }
    },

    onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.CustName = _selected.CustName;
        this.model.customer_id = _selected.customer_id;
        this.lkuCustomerShow=false;
    },

    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        totalDtlPaym = totalDtlPaym || 0;
        this.arpaymdt.items.forEach( function (trx) {
             totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank || 0);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='koran.paymfrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'koran.paymlist'});
      }
    }
  }
};
</script>
